import React, { useState } from "react";
import { Redirect } from 'react-router-dom'
import { TableRow } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles'

const PoliticasPrivacidadGridRow = (props) => {
	const intl = props.intl
	const politica = props.politica
	const baseUrl = props.baseUrl

	const [redirectTo, setRedirectTo] = useState(null)

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<TableRow>
				<StyledTableCell align="left">
					{politica.id}
				</StyledTableCell>
				<StyledTooltip arrow placement="right">
					<td
						align="left"
						className={(politica.activo ? "status-green" : "status-red") + " p-0 all custom-lineHeight br"}
						style={{ maxWidth: "3px" }}
					/>
				</StyledTooltip>
				<StyledTableCell align="left">
					{politica.titulo}
				</StyledTableCell>
				<StyledTableCell align="left">
					{politica.version}
				</StyledTableCell>
				<StyledTableCell align="left">
					{politica.activo
						? <span style={{ color: '#28d094' }}><FormattedMessage id="politicasPrivacidad.activo" defaultMessage="Activo" /></span>
						: <span style={{ color: '#6c757d' }}><FormattedMessage id="politicasPrivacidad.historica" defaultMessage="Histórica" /></span>
					}
				</StyledTableCell>
				<StyledTableCell>
					<div className="d-inline-flex">
						{props.canVisualizar &&
							<button
								className="action view btn btn-sm btn-icon btn-dt-grid text-success"
								title={intl.formatMessage({ id: 'Ver', defaultMessage: 'Ver' })}
								onClick={() => setRedirectTo(baseUrl + '/' + politica.id)}
							>
								<i className="fa fa-search fa-xs" />
							</button>
						}
						{props.canCrear && politica.activo === 1 &&
							<button
								className="action btn btn-sm btn-icon btn-dt-grid text-primary"
								title={intl.formatMessage({ id: 'politicasPrivacidad.nueva_version', defaultMessage: 'Nueva Versión' })}
								onClick={() => setRedirectTo(baseUrl + '/' + politica.id + '/nueva-version')}
							>
								<i className="fa fa-copy fa-xs" />
							</button>
						}
					</div>
				</StyledTableCell>
			</TableRow>
		</>
	)
}

export default PoliticasPrivacidadGridRow
